module.exports = __webpack_public_path__ + "img/1722992035673-kue nesy.jpg.c0e04588.webp";